<template>
  <div
    class="xxxlm-loading"
  >
    <!-- <a-icon type="loading" :style="{ 'font-size': '4rem', 'color': color }" /> -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    color: {
      type: String,
      default: 'inherit'
    },
    absolute: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style scoped>
  .lm-loading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 70px - 60px);
  }
  .lm-loading.absolute {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>
